import PropTypes from 'prop-types';
import React from 'react';
import { get } from 'lodash';
import {
  Button,
  Checkbox,
  Text,
  SingleSelectionGroup,
  TextInput,
} from 'pp-react';

import TermsModal from './termsModal';
import * as analytics from '../lib/analytics';
import parseAmount from '../lib/parseAmount';
import { isPPGF } from '../lib/charity';
import content from '../lib/i18n';
import classNames from 'classnames';
import styles from './donateBox.less';
const i18n = content('hub/components/donateBox');

export default class extends React.Component {
  static contextTypes = {
    csrf: PropTypes.string,
  };

  static defaultProps = {
    active: true,
  };

  constructor(props) {
    super(props);
    let nonanonymous = true;
    if (get(props, 'charity.address.country_code') === 'GB') {
      nonanonymous = false;
    }

    this.state = {
      nonanonymous,
      recurring: false,
      selectedAmount: '',
      clickedIndex: -1,
      inputAmount: '',
      radioBtnClicked: false,
      errorPopup: false,
    };
  }

  handleNonAnonymousCheck = event => {
    this.setState(
      Object.assign({}, this.state, {
        nonanonymous: event.target.checked,
      })
    );
  };

  handleInputChange = event => {
    const value = event.target.value;
    let input = parseAmount(value);
    if (input === undefined) {
      return this.invalid();
    }

    this.setState({
      inputAmount: input,
    });
  };

  handleInputFocus = () => {
    this.setState({
      selectedAmount: '',
      radioBtnClicked: false,
      clickedIndex: -1,
    });
  };

  invalid = () => {
    this.setState({
      isInvalid: true,
    });

    setTimeout(() => {
      this.setState({
        isInvalid: false,
      });
    }, 2000);
  };

  handleDonateClick = event => {
    if (
      this.state.inputAmount === '' &&
      (!this.state.radioBtnClicked || this.state.selectedAmount === '')
    ) {
      event.preventDefault();
      this.invalid();
      this.setState({
        errorPopup: true,
      });
      setTimeout(() => {
        this.setState({
          errorPopup: false,
        });
      }, 2000);
    }

    analytics.trackLinkWithData(
      'donatebutton',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      {
        amt: this.state.selectedAmount || this.state.inputAmount,
        nonanonymous: this.state.nonanonymous,
      },
      'link'
    );
  };

  handleAmountSelection = (event, index) => {
    this.setState({
      selectedAmount: event.target.value,
      clickedIndex: index,
      radioBtnClicked: true,
      inputAmount: '',
    });
  };

  donationForm = () => {
    const anonymousLabel = this.props.charityContent
      ? i18n(this.props.charityContent.anonymousCheck)
      : this.props.anonymousLabel;

    let nonAnonymousInput;
    if (isPPGF(this.props.charity.charity_type)) {
      nonAnonymousInput = (
        <Checkbox
          checked={this.state.nonanonymous}
          label={anonymousLabel}
          onClick={this.handleNonAnonymousCheck}
          name='nonanonymous-checkbox'
        />
      );
    }

    let name;
    if (isPPGF(this.props.charity.charity_type)) {
      name = i18n('label.ppgf-donation-description', {
        charity: this.props.charity.name,
      });
    } else {
      name = i18n('label.donation-description', {
        charity: this.props.charity.name,
      });
    }

    return (
      <form action={this.props.formUrl} method={'post'}>
        <input
          type={'hidden'}
          name={'_csrf'}
          value={this.props.csrf || this.context.csrf}
        />
        <input type={'hidden'} name={'npid'} value={this.props.nonprofit_id} />
        <input
          type={'hidden'}
          name={'eventUrl'}
          value={this.props.eventUrl || 'eventUrl'}
        />
        <input type={'hidden'} name={'name'} value={name} />
        <input
          type={'hidden'}
          name={'nonanonymous'}
          value={this.state.nonanonymous}
        />
        <input
          type={'hidden'}
          name={'currency'}
          value={this.props.amounts.currencyCode}
        />
        <input
          type={'hidden'}
          name={'amount'}
          value={
            this.state.selectedAmount
              ? this.state.selectedAmount
              : this.state.inputAmount
          }
        />
        {nonAnonymousInput}
        <Button
          className={styles['donateButton']}
          disabled={!this.props.active}
          type={'submit'}
          onClick={this.handleDonateClick}
          id={'nemo_donatebuttonNPO'}
        >
          {i18n('label.donate-now')}
        </Button>
      </form>
    );
  };

  renderDonationError = () => {
    if (this.props.donationInfo && this.props.donationInfo.donated === 2) {
      return (
        <div className={'npo-chkout-error-msg'}>
          <div className={'iconStyling'}>
            <img src='https://www.paypalobjects.com/images/Cause/ic_critical.svg' />
          </div>
          <div className={'errStyling'}>
            <Text as='p' size='md'>
              {i18n('label.error-msg')}
            </Text>
          </div>
          <br />
        </div>
      );
    }
  };

  render() {
    const inputBoxStyling = classNames(styles['textInputMargin'], {
      showError: this.state.errorPopup,
    });
    const currencyCode = this.props.amounts.currencyCode;
    const otherAmountPlaceholder = `${i18n(
      'label.other-amount'
    )} (${currencyCode})`;

    const selectionOptions = this.props.amounts.options.map((option, index) => {
      return {
        label: option.formatted,
        value: option.value,
      };
    });

    const modal = (
      <div>
        <div
          style={{
            fontFamily: 'pp-sans-small-regular',
            width: '90%',
            margin: '0 auto',
          }}
          dangerouslySetInnerHTML={{
            __html: i18n('label.modal-content-donate'),
          }}
        />
      </div>
    );

    return (
      <div style={{ paddingTop: '20px' }}>
        <TermsModal
          renderModalBody={modal}
          showModal={this.state.showModal}
          close={() => this.setState({ showModal: false })}
        />
        <SingleSelectionGroup
          name='rating'
          align='justify'
          value={this.state.selectedAmount}
          onChange={e => this.handleAmountSelection(e)}
          options={selectionOptions}
        />
        <TextInput
          name='help'
          type={'text'}
          id={'nemo_inputAmount'}
          errorText={this.state.errorPopup && i18n('label.inputError')}
          helperText={this.state.isInvalid && i18n('label.invalidInput')}
          className={`${inputBoxStyling}`}
          onChange={this.handleInputChange}
          onFocus={this.handleInputFocus}
          value={this.state.inputAmount}
          label={otherAmountPlaceholder}
          autoComplete={'off'}
          required
        />
        {this.donationForm()}
      </div>
    );
  }
}
